import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isUpdatePlanzoneContactsRequestFailure({ uuid }) {
      const state = getState().find((req) => req.planzone.uuid === uuid);

      return state ? state.request.isFailure : false;
    },
    isUpdatePlanzoneContactsRequestPending({ uuid }) {
      const state = getState().find((req) => req.planzone.uuid === uuid);

      return state ? state.request.isPending : false;
    },
    isUpdatePlanzoneContactsRequestSuccess({ uuid }) {
      const state = getState().find((req) => req.planzone.uuid === uuid);

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
